module.exports = __webpack_public_path__ + "img/44-native.53178b65.svg";